import { inject, Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ApplicantDetails } from "../../../models/applicant/applicant-details";
import { MCAddress, MCCommunicationDetails, MCFormStateService } from "@maslul/common-services";
import { ApplicantDetailsStore } from "../../store/applicant-details";



@Injectable({ providedIn: 'root' })
export class ApplicantDetailsService {

    private mcFormStateService = inject(MCFormStateService);
    private applicantDetailsStore = inject(ApplicantDetailsStore);

    saveToStore(applicantDetailsForm: FormGroup) {
        const applicant = this.convertApplicantFormGroupToModel(applicantDetailsForm);
        this.applicantDetailsStore.setApplicant(applicant);
    }

    convertApplicantFormGroupToModel(applicantFormGroup: FormGroup): ApplicantDetails {
        const applicant = new ApplicantDetails();
        const applicantFormGroupValue = applicantFormGroup.value;

        if (!applicantFormGroupValue) {
            return applicant;
        }

        applicant.userId = applicantFormGroupValue.userId;
        applicant.firstName = applicantFormGroupValue.firstName;
        applicant.lastName = applicantFormGroupValue.lastName;

        applicant.communicationDetails = new MCCommunicationDetails();
        applicant.communicationDetails.mobile = applicantFormGroupValue.mobile;
        applicant.communicationDetails.email = applicantFormGroupValue.email;

        applicant.address = new MCAddress();
        applicant.address.city = applicantFormGroupValue.city;
        applicant.address.street = applicantFormGroupValue.street;
        applicant.address.homeNumber = applicantFormGroupValue.homeNumber;
        applicant.address.postalCode = applicantFormGroupValue.postalCode;

        applicant.isPackageYours = applicantFormGroupValue.isPackageYours;

        if (applicantFormGroupValue.packageOwnerGroup) {
            applicant.packageOwnerId = applicantFormGroupValue.packageOwnerGroup.packageOwnerId;
            applicant.packageOwnerFirstName = applicantFormGroupValue.packageOwnerGroup.packageOwnerFirstName;
            applicant.packageOwnerLastName = applicantFormGroupValue.packageOwnerGroup.packageOwnerLastName;

            applicant.packageOwnerCommunicationDetails = new MCCommunicationDetails();
            applicant.packageOwnerCommunicationDetails.mobile = applicantFormGroupValue.packageOwnerGroup.packageOwnerMobile;
            applicant.packageOwnerCommunicationDetails.email = applicantFormGroupValue.packageOwnerGroup.packageOwnerEmail;

            applicant.powerOfAttorney = applicantFormGroupValue.packageOwnerGroup.powerOfAttorney;
        }

        return applicant;
    }

    updateFormState() {

        const isPackageYours = this.applicantDetailsStore.getSnapshot().applicant?.isPackageYours;
        const isFilledByImporter: boolean = isPackageYours === 'yes';
        this.mcFormStateService.setFormState('isFilledByImporter', isFilledByImporter);
    }

}
